import { createSlice } from "@reduxjs/toolkit";
import { getOrganisations, getOrganisationById, addOrganisation, updateOrganisation, deleteOrganisations } from "./actions";
import { IOrganisationsState } from "./types";

const initialState: IOrganisationsState = {
  loading: {
    getOrganisations: false,
    getOrganisationById: false,
    addOrganisation: false,
    updateOrganisation: false,
    deleteOrganisations: false,
  },
  organisations: [],
  selectedOrganisation: null,
  error: null,
};

export const organisationsSlice = createSlice({
  name: "organisations",
  initialState,
  reducers: {
    clearOrganisationState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getOrganisations.pending, (state) => {
      state.loading.getOrganisations = true;
    });
    builder.addCase(getOrganisations.rejected, (state) => {
      state.loading.getOrganisations = false;
    });
    builder.addCase(getOrganisations.fulfilled, (state, action) => {
      state.loading.getOrganisations = false;
      state.organisations = action.payload;
    });
    builder.addCase(getOrganisationById.pending, (state) => {
      state.loading.getOrganisationById = true;
    });
    builder.addCase(getOrganisationById.rejected, (state) => {
      state.loading.getOrganisationById = false;
    });
    builder.addCase(getOrganisationById.fulfilled, (state, action) => {
      state.loading.getOrganisationById = false;
      state.selectedOrganisation = action.payload;
    });
    builder.addCase(addOrganisation.pending, (state) => {
      state.loading.addOrganisation = true;
    });
    builder.addCase(addOrganisation.rejected, (state) => {
      state.loading.addOrganisation = false;
    });
    builder.addCase(addOrganisation.fulfilled, (state) => {
      state.loading.addOrganisation = false;
    });
    builder.addCase(updateOrganisation.pending, (state) => {
      state.loading.updateOrganisation = true;
    });
    builder.addCase(updateOrganisation.rejected, (state) => {
      state.loading.updateOrganisation = false;
    });
    builder.addCase(updateOrganisation.fulfilled, (state) => {
      state.loading.updateOrganisation = false;
    });
    builder.addCase(deleteOrganisations.pending, (state) => {
      state.loading.deleteOrganisations = true;
    });
    builder.addCase(deleteOrganisations.rejected, (state) => {
      state.loading.deleteOrganisations = false;
    });
    builder.addCase(deleteOrganisations.fulfilled, (state) => {
      state.loading.deleteOrganisations = false;
    });
  },
});

export const { clearOrganisationState } = organisationsSlice.actions;

